export const applyVolumeToVideoElement = (videoElement: HTMLVideoElement, volume: number) => {
  if (!volume || volume < 0) {
    videoElement.muted = true;
    videoElement.volume = 0;
  } else {
    // todo
    const newVolume = Math.min(volume, 1);
    if (!isNaN(newVolume)) {
      videoElement.muted = false;
      videoElement.volume = newVolume;
    }
  }
};

export const noop = () => {};

export const removeElementFromDocument = (element?: Node | null) => {
  if (element && element.parentNode) {
    element.parentNode.removeChild(element);
  }
};
